import React from "react";
import { RadioButtonComponent } from "@syncfusion/ej2-react-buttons";
import {
  getCurrentLangFromRedux,
  getDir,
} from "../../../algorithms/styleChanges";
const RadioButton = ({
  checked,
  name,
  label,
  value,
  containerStyle,
  change,
}) => {
  return (
    <div className={`${containerStyle}`}>
      <RadioButtonComponent
        label={label}
        change={change}
        name={name}
        value={value}
        enableRtl={getDir(getCurrentLangFromRedux()) == "ltr" ? false : true}
        checked={checked ?? false}
      ></RadioButtonComponent>
    </div>
  );
};

export default RadioButton;
